import { PropsWithChildren } from 'react';

import PostAsideTitle from './PostAsideTitle';
import Divider from '../Divider';

import style from './post-aside-section.module.css';

interface PostAsideSectionProps {
  sectionTitle: string;
}

const PostAsideSection = ({
  children,
  sectionTitle,
}: PropsWithChildren<PostAsideSectionProps>) => {
  return (
    <section className={style.postAsideSection}>
      <Divider
        thickness={2}
        variant="gradient"
      />

      <PostAsideTitle>
        {sectionTitle}
      </PostAsideTitle>

      {children}
    </section>
  );
};

export default PostAsideSection;
